module.exports = __webpack_public_path__ + "static/media/load.cbf3e8f8.gif";